module.exports = __webpack_public_path__ + "img/5.501c016a.webp";